import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

export async function signInWithGoogle() {
  const result = await signInWithPopup(firebaseAuth, googleProvider);
  return result.user.getIdToken();
}

export async function signInWithFacebook() {
  const result = await signInWithPopup(firebaseAuth, facebookProvider);
  return result.user.getIdToken();
}

export async function signInWithEmailPassword(email: string, password: string) {
  const result = await signInWithEmailAndPassword(firebaseAuth, email, password);
  return result.user.getIdToken();
}

export async function signUpWithEmailPassword(email: string, password: string) {
  const result = await createUserWithEmailAndPassword(firebaseAuth, email, password);
  return result.user.getIdToken();
}

export async function getCurrentIdToken(): Promise<string | null> {
  const user = firebaseAuth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function signOutFirebase() {
  await firebaseSignOut(firebaseAuth);
}
